import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import MemberPanelAuth from "../../Utilities/MemberPanelAuth";

function ProtectedMemberPanelRoute({ children }) {
  // hooks
  const location = useLocation();
  const navigate = useNavigate();
  // getting data from redux store
  const { is_auth } = useSelector((state) => state.memberPanelAuthSlice);
  // token existance
  const { token } = MemberPanelAuth.getSessionData();

  useEffect(() => {
    if (!token) {
      navigate("/member-login");
    }
  }, [location, is_auth]);

  if (token) {
    return <>{children}</>;
  } else return <>Authenticating...</>;
}

export default ProtectedMemberPanelRoute;
